import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=049fc007&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=049fc007&prod&scoped=true&lang=scss"
import style1 from "./StatusIndicator.vue?vue&type=style&index=1&id=049fc007&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fc007",
  null
  
)

export default component.exports